import { PaletteMode } from '@mui/material';
import { createContext, useContext } from 'react';

export const SDKPaletteModeContext = createContext<PaletteMode | undefined>(undefined);

export const useSDKPaletteMode = () => {
  return useContext(SDKPaletteModeContext);
};
